<template>
  <div>
    <div class="wall">
      <div class="wall-head">订单列表</div>
      <search-bar class="media-body"  @on-search="handleSearch"/>
    </div>
    <div class="mt-30 wall">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="" name="0"></el-tab-pane>
        <el-tab-pane label="全部订单" name="all"></el-tab-pane>
        <el-tab-pane label="待付款" name="unpaid"></el-tab-pane>
        <el-tab-pane label="待发货" name="unsend"></el-tab-pane>
        <el-tab-pane label="已发货" name="unreceived"></el-tab-pane>
        <el-tab-pane label="已完成" name="finished"></el-tab-pane>
        <!-- <el-tab-pane label="退款中" name="5"></el-tab-pane> -->
        <el-tab-pane label="已关闭" name="cancel"></el-tab-pane>
      </el-tabs>
      <div class="flex-inline sub-pagination mt-10 pl-40">
        <!-- 批量导出 -->
        <div class="flex-inline">
          <!-- <el-button size="small" @click="handleCheckAllChange">全选/清空</el-button> -->
          <!-- <el-button size="small" @click="hanelExport">批量导出</el-button> -->
          <!-- <el-button v-if="activeName==='all'||activeName==='unsend'" size="small" @click="showDeliverDialog">批量发货</el-button> -->
          <!-- <div class="color-lightGray ml-10">选中订单（{{ multipleSelection.length }}）</div> -->
        </div>
        <!-- 批量发货 -->
        <!-- <div v-if="activeName === 'unsend'" class="flex-inline">
          <el-button size="small" @click="hanelFailList"></el-button>
          <div class="color-lightGray ml-10">选中订单（{{ multipleSelection.length }}）</div>
        </div> -->
      </div>
      <div class="p-30">
        <div v-if="!bodyLoading && tableData.length < 1" class="flex-center-center">
          <div class="color-lightGray">暂无数据</div>
        </div>
        <el-checkbox-group v-model="checkedOrders" @change="handleCheckedOrderChange">
          <table class="order-table" border="0" cellspacing="0" cellpadding="0" v-loading="bodyLoading">
            <template v-for="(order, index) in tableData">
              <tr :key="index" class="head">
                <td style="width: 60px">
                  <el-checkbox :label="order.order_id" >选择
                  </el-checkbox>
                  <!-- 创建时间：{{ order.create_time }} -->
                </td>
                <td>{{ order.order_id }}</td>
                <td align="center">单价</td>
                <td align="center">数量</td>
                <td align="center">客户</td>
                <td align="center">退款状态</td>
                <td align="center">订单状态</td>
                <td align="center">总额</td>
              </tr>
              <template v-for="(good, gIndex) in order.skus">
                <tr v-if="gIndex == 0" :key="gIndex + 'index-add' + index">
                  <td colspan="8">
                    <div class="flex-items-center mt-10 mb-10 color-sliver">
                      <div class="el-icon-location fs-20" />
                      <div class="ml-5">{{ order.address.receiver }}</div>
                      <div class="ml-5">{{ order.address.mobile }}</div>
                      <div class="ml-5">
                        {{ order.address.province }}
                        {{ order.address.city }}
                        {{ order.address.district }}
                        {{ order.address.place }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr :key="gIndex + 'index' + index">
                  <td />
                  <td class="pt-10 pb-30" style="width: 320px;">
                    <div class="d-flex">
                      <img :src="good.sku.picture + ''" alt="" style="width: 80px; height: 80px;">
                      <div class="p-10 d-flex flex-column flex-body" style="width: 220px;">
                        <div class="clamp">{{ good.sku.title }}</div>
                        <!-- <div class="mt-10">规格：{{ good.modal }}</div> -->
                        <div class="mt-auto color-sliver">{{ good.sku.specs|obj_to_string }}</div>
                        <div class="mt-10 color-sliver">商家编码：{{ good.sku.spu || good.sku.code }}</div>
                      </div>
                    </div>
                  </td>
                  <td align="center">
                    <span class="text-price">{{ good.price }}</span>
                  </td>
                  <td align="center">{{ good.count }}</td>
                  <td align="center" v-if="gIndex == 0" :rowspan="order.skus.length">
                    {{ order.cuser || order.user_id }}
                  </td>
                  <td align="center" v-if="gIndex == 0&&good.aftersale_status" :rowspan="order.skus.length" :style="{color:statusObj[good.aftersale_status].color}">
                    {{statusObj[good.aftersale_status].text }}
                  </td>
                  <td align="center" v-if="gIndex == 0" :rowspan="order.skus.length">
                    <p v-if="order.status === 'unpaid'" class="color-primary">待付款</p>
                    <p v-if="order.status === 'unsend'" class="color-green">待发货</p>
                    <p v-if="order.status === 'unreceived'">已发货</p>
                    <p v-if="order.status === 'finished'">已完成</p>
                    <p v-if="order.status === '5'">退款中</p>
                    <p v-if="order.status === 'cancel'" class="color-lightGray">已关闭</p>
                    <p v-if="order.status === 'assured'">已入账</p>
                    <el-button
                      v-if="order.status === 'unsend'"
                      size="mini"
                      class="mt-10"
                      type="success"
                      @click="handleShipper(order)"
                      round>发货</el-button>
                    <div class="mt-10">
                      <!-- <router-link
                        :to="{ path: '/order/item', query: { order_id: order.order_id } }"
                        class="color-primary"
                      >
                        详情
                      </router-link> -->
                    </div>
                  </td>
                  <td align="center" v-if="gIndex == 0" :rowspan="order.skus.length">
                    <div class="text-price">{{ order.pay_amount }}</div>
                    <!-- <div class="mt-10">(含运费：<span class="text-price">0</span>)</div> -->
                    <div class="mt-10">(福利券抵扣：<span class="text-price">{{ Math.ceil(order.pay_welfare) }}</span>)</div>
                  </td>
                </tr>
              </template>
            </template>
          </table>
        </el-checkbox-group>
      </div>


      <div class="flex-center-center pb-20"> 
        <el-pagination
          background
          layout="sizes, total, prev, pager, next"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="currentPage"
          :total="totalItems"
          @current-change="handlePageChage"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <el-dialog
      title="批量发货" 
      :visible.sync="deliverVisible" 
      width="600px">
        <el-alert
          class="p-10"
          title="导入前，请按照模板编辑EXCEL文档，并将所有列设置成文本格式"
          type="warning"
          show-icon>
        </el-alert>
      <div class="color-red mt-30 mb-30">
        <a class="color-red" href="/static/import-demo.xlsx">下载模板</a>
      </div>
      <input class="file" type="file" @change="inputFileChange"/>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deliverVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmDeliver" :loading="dialogLoading">发货</el-button>
      </div>
    </el-dialog>

    <send-dialog ref="sendDialog" />
  </div>
</template>

<script>
import SearchBar from './components/Searchbar.vue';
import { getOrderList, uploadOrderFile, exportOrderFile } from '@/api/order.js';
import SendDialog from './components/SendDialog.vue';

export default {
  components: {
    SearchBar,
    SendDialog
  },
  data() {
    return {
      bodyLoading: false,
      activeName: 'all',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      tableData: [],
      checkAll: false,
      checkedOrders: [],
      deliverVisible: false,
      file: null,
      dialogLoading: false,
      statusObj:{
        unapply:{text:'暂无',color:'#999999'},
        unaudited:{text:'待商家处理',color:'#67C23A'},
        processing: {text:'处理中',color:'#67C23A'},
        cancel: {text:'已取消',color:'#999999'},
        refused: {text:'已拒绝',color:'#ED4645'},
        refunded: {text:'已退款',color:'#999999'},
        returned: {text:'已退货',color:'#999999'}
      },
    }
  },
  created() {
    this.loadOrderList();
  },
  methods: {
    async loadOrderList(data = {}) {
      this.bodyLoading = true
      let params = Object.assign({
        limit: this.pageSize,
        offset: (this.currentPage - 1) * this.pageSize
        }, data);
      if (this.activeName !== 'all') params.status = this.activeName;
      let { results, count } = await getOrderList(params);
      this.totalItems = count;
      this.tableData = results
      this.bodyLoading = false
    },
    // 切换页码
    handlePageChage(v) {
      this.currentPage = v;
      this.loadOrderList();
    },
    handleSizeChange(v) {
      this.pageSize = v
      this.currentPage = 1
      this.loadOrderList()
    },
    // 搜索
    handleSearch(data) {
      // 删除空值
      Object.keys(data).forEach(key => {
        if (data[key] == null || data[key] == '') {
          delete data[key];
        }
      })
      this.currentPage = 1;
      this.loadOrderList(data);
    },
    // 发货 
    handleShipper(order) {
      this.$router.push({ path: `/order/item`, query: { order_id: order.order_id } })
    },
    // Tab页切换
    handleClick() {
      this.currentPage = 1;
      this.loadOrderList();

      // 清空已选择的数据 重置全选
      this.checkedOrders = []
      this.checkAll = false
    },
    async hanelExport() {
      if(!this.checkedOrders.length){return}
      const data = await exportOrderFile({order_ids: this.checkedOrders})
      const url = window.URL.createObjectURL(new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}))
        const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      let date = new Date();
      let dateString = date.getFullYear();
      dateString += date.getMonth() < 9 ? '0' + (date.getMonth() + 1) :(date.getMonth() + 1);
      dateString += date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      
      dateString += date.getHours() < 10 ? '0' + date.getHours() : + date.getHours();
      dateString += date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      dateString += date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      link.setAttribute('download', dateString+'.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleCheckedOrderChange(value){
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.tableData.length;
    },
    handleCheckAllChange(){
      this.checkAll = !this.checkAll
      this.checkedOrders = this.checkAll  ? this.tableData.map(order=>{return order.order_id}) : [] 
    },
    showDeliverDialog(){
      this.$refs['sendDialog'] && this.$refs['sendDialog'].show();
      // this.deliverVisible = true
    },
    async confirmDeliver(){
      const data = new FormData()
      data.append('excel_file',this.file)
      try {
        await uploadOrderFile(data)
        this.$message.success('发货成功');
        this.loadOrderList();
      }
      catch(e) {
        console.log(e)
      }
    },
    inputFileChange(e){
      if(!e.target.files.length){return}
      this.file = e.target.files[0];
    }
    // 计算福利券抵扣数量
    // calcWelfareAmount(item) {
    //   let _amount = 0;
    //   item.skus.forEach(sku => {
    //     _amount += (sku.count * Math.ceil(sku.sku.welfare));
    //   })
    //   return _amount;
    // }
  }
}
</script>

<style scoped lang="scss">
.order-table {
  width: 100%;
  font-size: 12px;
  color: $black;
  .head {
    background-color: rgba(255,125,98,0.06);
    color: $lightGray;
    td {
      padding: 10px 5px;
      border: none;
    }
  }
}
</style>